import { Thinking } from '@shared/assets';

import * as st from './Blank.module.scss';

interface Props {
	text?: string;
}

const Blank = ({ text }: Props) => {
	return (
		<div className={st.blank}>
			<Thinking />
			<span className={st.blank__text}>{text}</span>
		</div>
	);
};

export default Blank;
